export default "__VITE_ASSET__CcRlrQ$v__"